(() => {
  const initialize = () => {
    const targets = [...document.querySelectorAll('#judgeme_product_reviews')];
    if (!targets.length) return;
    const reveal = (element) => element.setAttribute('data-render-ready', '');
    if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
      targets.forEach(reveal);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '600px 0px' });
    targets.forEach((element) => {
      observer.observe(element);
      element.addEventListener('focusin', () => {
        reveal(element);
        observer.unobserve(element);
      }, { once: true });
    });
    const review = document.getElementById('judgeme_product_reviews');
    if (review) {
      document.addEventListener('click', (event) => {
        if (event.target.closest?.('.jdgm-preview-badge, .jdgm-prev-badge, a[href*="judgeme_product_reviews"]')) {
          reveal(review);
          observer.unobserve(review);
        }
      }, { capture: true });
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
